import { render } from "./CounterButtonsPage.vue?vue&type=template&id=314f6c2a&scoped=true"
import script from "./CounterButtonsPage.vue?vue&type=script&lang=js"
export * from "./CounterButtonsPage.vue?vue&type=script&lang=js"

import "./CounterButtonsPage.vue?vue&type=style&index=0&id=314f6c2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314f6c2a"]])

export default __exports__